import { Injectable } from '@angular/core';
import { AppCollection } from '../app.config';
import { BaseCollectionService } from '../core/jsonApi/BaseCollectionService';
import { TestJsonModel } from './test.json.model';

@Injectable({
  providedIn: 'root'
})
export class TestService extends BaseCollectionService<TestJsonModel, AppCollection> {
  protected ctor = TestJsonModel;
}
